import { useState } from "react";
import { api, fmtError } from "@/lib/api";
import { ScrollText, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

const RULES = [
  "Respect everyone.", "No hate speech.", "No religious or political abuse.",
  "No misinformation.", "No harassment.", "No spam.", "Respect privacy.",
];

export const GuidelinesGate = ({ onAccepted }) => {
  const [busy, setBusy] = useState(false);
  const accept = async () => {
    setBusy(true);
    try { await api.post("/community/guidelines/accept"); toast.success("Welcome to the community!"); onAccepted(); }
    catch (e) { toast.error(fmtError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="px-5 pt-8" data-testid="guidelines-gate">
      <div className="bg-white rounded-3xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-[#111827]/5">
        <div className="w-14 h-14 rounded-2xl bg-[#C4B5FD]/25 flex items-center justify-center mb-4"><ScrollText className="w-7 h-7 text-[#7c3aed]" /></div>
        <h1 className="text-2xl font-bold font-head">Community Guidelines</h1>
        <p className="text-[#111827]/60 mt-1 mb-5">Please read and accept before you take part in the community.</p>
        <ul className="space-y-3">
          {RULES.map((r) => (
            <li key={r} className="flex items-start gap-3"><div className="w-6 h-6 rounded-full bg-[#16A34A]/15 flex items-center justify-center shrink-0 mt-0.5"><Check className="w-3.5 h-3.5 text-[#16A34A]" /></div><span className="text-[#111827]/85">{r}</span></li>
          ))}
        </ul>
        <p className="text-xs text-[#111827]/45 mt-5">HumNest never groups or ranks people by religion, caste, ethnicity or politics. Report anything that breaks these rules.</p>
        <button data-testid="accept-guidelines" onClick={accept} disabled={busy} className="w-full bg-[#F97316] text-white rounded-2xl py-4 font-bold mt-5 min-h-[56px] flex items-center justify-center gap-2">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "I agree — enter community"}</button>
      </div>
    </div>
  );
};
